export const RIBBON_TRANS = {
	DO_NOT_SHOW: "Již nezobrazovat",
	SHOW_AUTOMATICALLY: "Zobrazit automaticky",
	SETTINGS_ENABLED_TITLE: "Vždy rozbalené aktuality v oblasti",
	SETTINGS_ENABLED_DESC: "Nad mapou automaticky zobrazíme pás s aktualitami v oblasti",
	TOOLTIP_MINIMALIZE: "Od teď budou aktuality v oblasti vždy minimalizované, vytáhnete je pomocí šipky.",
	TOOLTIP_HIDE: "Od teď budou aktuality v oblasti vždy skryté. Změnit to můžete v {link}.",
	TOOLTIP_HIDE_LINK: "nastavení",
};
